import type { FunctionComponent } from "react";
import { CarouselItemFormPartial } from "../../../partials/admin/carousel/carousel-item-form.admin.partials";

const CreateCarouselItemAdminScreen: FunctionComponent = () => {
  return <CarouselItemFormPartial mode="create" />;
};

export default CreateCarouselItemAdminScreen;
